import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../core/configs/app-config';
import {SelectItem} from 'primeng/api';
@Component({
    selector: 'afdeling-dialog',
    templateUrl: 'afdelingdialog.component.html',
    styleUrls  : ['./afdelingdialog.component.scss']
  })
  export class PlanningMdwAfdelingDialog {
    selectedAfdelingen: any[] = [];
    afdelingen: SelectItem[] = [];
    config: any;
    constructor(public dialogRef: MatDialogRef<PlanningMdwAfdelingDialog>,@Inject(MAT_DIALOG_DATA) public data:  any[], @Inject(HttpClient) private http?: HttpClient) {
      this.config = {
        "SERVERPROTOCOL": AppConfig.ApiProtocol,
        "SERVERURL": AppConfig.ApiLoginHost,
        "SERVERPORT": AppConfig.ApiPort,
        "APPLICATIONID": AppConfig.ApiApplicationId,
        "METHOD": AppConfig.ApiMethod,
        "LOGINURL": AppConfig.ApiLoginUrl,
        "STACKURL": AppConfig.ApiUrl
      };
      
      
    }

        ngOnInit() {
      
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/departments/overview";
      
          var get = this.http.get(conString);
          get.subscribe(     
          (results:any) => {
          for (var result of  results){ 
            this.afdelingen.push(<SelectItem>{ label:result["Afdeling"], value:result["AfdID"]});
          }  
          this.selectedAfdelingen=this.afdelingen.filter(a=>this.data["afdeling"].includes(a.value)).map(a=>a.value);
          },
          (error) => {
          console.error(error);
          });
        }
    btnOpslaan(){
      console.log(this.selectedAfdelingen);
      this.dialogRef.close(this.selectedAfdelingen);
     }
  }